import typography from '@amblique/king-living/app/theme/foundations/typography';

const CHECKOUT_FILLED_BUTTON_HOVER = {
  bg: 'white',
  borderColor: 'brandColors.greyscale',
  color: 'brandColors.greyscale',
};

const CHECKOUT_OUTLINED_BUTTON_HOVER = {
  bg: 'brandColors.greyscale',
  borderColor: 'brandColors.greyscale',
  color: 'white',
};

const CheckoutPage = {
  parts: [
    'contentWrapper',
    'pageContainer',
    'pageHeading',
    'header',
    'headerInner',
    'headerDesktopRow',
    'headerMobileRow1',
    'headerMobileRow2',
    'linkContinue',
    'linkLogo',
    'headerLogoCenter',
    'linkNeedHelp',
    'logo',
    'trustBadges',
    'trustBadgesStripeRow',
    'trustBadgesBnplRow',
    'trustBadgesLockIcon',
    'trustBadgesCopy',
    'trustBadgesStripeBadge',
    'trustBadgesZipLogo',
    'trustBadgesAfterpayLogo',
    'trustBadgesClearpayBadge',
    'trustBadgesClearpayText',
    'disclaimer',
    'disclaimerText',
    'disclaimerSpacer',
    'placeOrderLegalNote',
    'placeOrderLegalNoteText',
    'placeOrderLegalNoteLink',
    'placeOrderCluster',
    'contentColumn',
    'summaryColumn',
    'headingColumn',
    'contentGrid',
    'stepsContainer',
    'addressGrid',
    'addressTile',
    'addressTileSelected',
    'addressTileRadio',
    'addressTileRadioInner',
    'addressTileBadge',
    'addressTileName',
    'addressTileAddress',
    'addressTileActions',
    'addressTileActionLink',
    'addressTileAddNew',
    'addressTileAddNewActive',
    'newAddressFormHeading',
    'addressFormActions',
    'addressFormSaveButton',
    'addressFormCancelButton',
    'submitButton',
    'shippingWarningAlert',
    'shippingMethodList',
    'shippingMethodOption',
    'shippingMethodOptionSelected',
    'shippingMethodRadio',
    'shippingMethodRadioSelected',
    'shippingMethodRadioInner',
    'shippingMethodContent',
    'shippingMethodHeaderRow',
    'shippingMethodTitle',
    'shippingMethodPrice',
    'shippingMethodPriceColumn',
    'shippingMethodPriceOriginal',
    'shippingMethodDetailRow',
    'shippingMethodDetailBullet',
    'shippingMethodDetailText',
    'shippingMethodPromotion',
    'shippingMethodSummary',
    'shippingMethodSummaryTitle',
    'shippingMethodSummaryLeadTime',
    'shippingMethodSummaryDescription',
    'shippingMethodSummaryPrice',
    'shippingMethodSummaryAdjustment',
    'paymentSectionHeading',
    'paymentMethodList',
    'paymentMethodOption',
    'paymentMethodOptionSelected',
    'paymentMethodOptionCompact',
    'paymentMethodHeaderRow',
    'paymentMethodTitle',
    'paymentMethodLogoBadge',
    'paymentMethodRadio',
    'paymentMethodRadioSelected',
    'paymentMethodRadioInner',
    'paymentMethodCardForm',
    'stripePaymentElementContainer',
    'paymentAmountList',
    'paymentAmountOption',
    'paymentAmountOptionSelected',
    'paymentAmountContent',
    'paymentAmountTitle',
    'paymentAmountSubtitle',
    'paymentAmountPrice',
  ],
  baseStyle: {
    pageContainer: {
      bg: 'brandColors.primaryBG',
      padding: {base: '0 20px', lg: '0 80px'},
      position: 'relative',
      overflow: 'hidden',
      borderTop: 'none',
    }, 
    contentWrapper: {
      maxWidth: '1280px',
      marginX: 'auto',
      paddingX: {base: 0, lg: 0},
      pb: {base: 0, lg: 0},
    },
    pageHeading: {
      ...typography.textStyles.headingXL,
      letterSpacing: {base: '-0.32px', lg: '-0.4px'},
      color: 'brandColors.greyscale90',
    },
    header: {
      bg: 'brandColors.primaryBG',
      borderBottomWidth: {base: 'none', lg: '1px'},
      borderBottomStyle: {base: 'none', lg: 'solid'},
      borderColor: {base: 'none', lg: 'gray.100'},
      px: 0,
      pt: {base: 0, lg: '40px'},
      width: '100%',
    },
    headerInner: {
      marginX: 'auto',
      maxWidth: '1440px',
      paddingX: {base: '20px', lg: '80px'},
      width: '100%',
    },
    headerDesktopRow: {
      align: 'center',
      display: {base: 'none', lg: 'flex'},
      maxH: '63px',
      justify: 'space-between',
      pb: {lg: '26px'},
      position: 'relative',
    },
    headerMobileRow1: {
      align: 'center',
      display: {base: 'flex', lg: 'none'},
      h: '60px',
      justify: 'space-between',
    },
    headerMobileRow2: {
      align: 'center',
      display: {base: 'flex', lg: 'none'},
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
      borderColor: 'gray.100',
      borderBottom: 'none',
      marginX: {base: '-20px', lg: '-80px'},
      paddingX: {base: '20px', lg: '80px'},
      paddingTop: {base: '24px', lg: 'unset'},
      paddingBottom: {base: 'unset', lg: 'unset'},
      h: {base: 'unset', lg: '44px'},
      justify: 'flex-start',
    },
    linkContinue: {
      alignItems: 'center',
      color: 'primary.darkLinen',
      display: 'inline-flex',
      fontSize: {base: '14px', lg: '18px'},
      fontWeight: {'base': '600', 'lg': '500'},
      gap: '8px',
      h: 'auto',
      lineHeight: {base: 1.4, lg: 1.6},
      minH: 'unset',
      minW: 'unset',
      px: 0,
      py: '4px',
      _focus: {
        outlineColor: 'brandColor.greyscale10',
      },
      sx: {
        '.chakra-button__icon': {
          marginInlineEnd: 0,
          marginInlineStart: 0,
        },
      },
    },
    linkLogo: {},
    headerLogoCenter: {
      left: '50%',
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      transform: 'translateX(-50%)',
      sx: {
        '& > *': {
          pointerEvents: 'auto',
        },
      },
    },
    linkNeedHelp: {
      color: 'greyscale.100',
      display: 'inline-flex',
      fontSize: {base: '14px', lg: '16px'},
      fontWeight: '400',
      h: 'auto',
      lineHeight: 1.4,
      minH: 'unset',
      minW: 'unset',
      px: 0,
      py: '4px',
      _focus: {
        outlineColor: 'brandColor.greyscale10',
      },
    },
    logo: {
      height: {base: '17px', lg: '24px'},
      width: {base: '76px', lg: '112px'},
    },
    // KL-1051 — Stripe trust + regional BNPL messaging (above legal disclaimer).
    trustBadges: {
      alignItems: {base: 'center', lg: 'flex-start'},
      display: 'flex',
      flexDirection: 'column',
      gap: {base: '15px', lg: '24px'},
      marginTop: {base: 0, lg: '80px'},
      width: '100%',
    },
    // Mobile: lock + copy + Stripe stay one row (no wrap).
    trustBadgesStripeRow: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      flexWrap: 'nowrap',
      gap: '4px',
      justifyContent: {base: 'flex-start', lg: 'flex-start'},
      maxW: '100%',
      width: {base: '100%', lg: 'auto'},
    },
    trustBadgesBnplRow: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      flexWrap: 'wrap',
      gap: '4px',
      justifyContent: {base: 'flex-start', lg: 'flex-start'},
      width: {base: '100%', lg: 'auto'},
    },
    trustBadgesLockIcon: {
      color: 'black',
      flexShrink: 0,
      h: '25px',
      w: '18px',
    },
    trustBadgesCopy: {
      color: 'black',
      flexShrink: 1,
      fontFamily: 'body',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: 1.2,
      minW: 0,
      whiteSpace: 'nowrap',
    },
    trustBadgesStripeBadge: {
      flexShrink: 0,
      h: '25px',
      objectFit: 'contain',
      w: {base: '96px', lg: '114px'},
    },
    trustBadgesZipLogo: {
      flexShrink: 0,
      h: '16px',
      objectFit: 'contain',
      w: '44px',
    },
    trustBadgesAfterpayLogo: {
      flexShrink: 0,
      h: '21px',
      objectFit: 'contain',
      w: '60px',
    },
    trustBadgesClearpayBadge: {
      alignItems: 'center',
      bg: '#B2FCE4',
      borderRadius: '999px',
      display: 'inline-flex',
      flexShrink: 0,
      h: '21px',
      justifyContent: 'center',
      px: '10px',
    },
    trustBadgesClearpayText: {
      color: 'black',
      fontFamily: 'body',
      fontSize: '11px',
      fontWeight: 600,
      letterSpacing: '-0.02em',
      lineHeight: 1,
      textTransform: 'lowercase',
    },
    disclaimer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      // Trust badges own the top offset; keep 24px under BNPL/Stripe rows (Figma).
      marginTop: {base: '15px', lg: '24px'},
      pb: {base: '24px', lg: '40px'},
      pt: 0,
    },
    disclaimerText: {
      color: 'brandColors.greyscale80',
      fontFamily: 'body',
      fontSize: {base: '13px', lg: '16px'},
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: {base: 1.2, lg: 1.4},
      textAlign: 'left',
      whiteSpace: 'pre-wrap',
    },
    disclaimerSpacer: {
      flexShrink: 0,
      height: {base: 'calc(13px * 1.2)', lg: 'calc(16px * 1.4)'},
      mb: 3,
      mt: 0,
      width: '100%',
    },
    placeOrderLegalNote: {
      textAlign: 'left',
      width: '100%',
    },
    placeOrderLegalNoteText: {
      color: 'brandColors.greyscale80',
      fontFamily: 'body',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.4,
      textAlign: 'left',
    },
    placeOrderLegalNoteLink: {
      color: 'brandColors.greyscale80',
      textDecoration: 'underline',
      _hover: {
        color: 'brandColors.greyscale80',
        textDecoration: 'underline',
      },
    },
    placeOrderCluster: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      marginBottom: '24px',
      width: '100%',
    },
    contentGrid: {
      gap: 0,
      templateColumns: {base: '1fr', lg: '57.0318% 1fr'},
      templateRows: {base: 'auto auto auto', lg: 'auto 1fr'},
      templateAreas: {
        base: '"heading" "summary" "steps"',
        lg: '"heading summary" "steps summary"',
      },
      alignItems: 'stretch',
    },
    headingColumn: {
      bg: 'brandColors.primaryBG',
      gridArea: 'textStyles.headingXL',
      paddingRight: {base: 0, lg: 20},
      paddingTop: {base: 4, lg: 20},
      paddingBottom: {base: 6, lg: 10},
    },
    contentColumn: {
      bg: 'brandColors.primaryBG',
      gridArea: 'steps',
      paddingRight: {base: 0, lg: '80px'},
    },
    summaryColumn: {
      bg:  {base: 'whiteAlpha.700', lg: 'transparent'},
      borderColor: 'blackAlpha.100',
      borderTopWidth: {base: '1px', lg: 0},
      borderBottomWidth: {base: '1px', lg: 0},
      borderStyle: 'solid',
      gridArea: 'summary',
      paddingLeft: {base: '20px', lg: '80px'},
      paddingRight: {base: '20px', lg: 'unset'},
      py: {base: '32px', lg: '80px'},
      maxWidth: {'base': 'unset','md': '110%', 'lg': '550px'},
      minWidth: {base: 0, lg: 'unset'},
      position: 'relative',
      marginLeft: {base: '-20px', lg: 'unset'},
      marginRight: {base: '-20px', lg: 'unset'},
      sx: {
        '&:before': {
          content: '""',
          display: 'block',
          width: '100vw',
          height: '100%',
          backgroundColor: {base: 'transparent', lg: 'whiteAlpha.700'},
          position: 'absolute',
          top: {base: 0, lg: '0'},
          left: 0,
          pointerEvents: 'none',
          zIndex: 0,
        },
        '&:has(.checkout-order-summary[data-mobile-expanded="true"])': {
          width: {base: 'calc(100% + 40px)', lg: 'auto'},
        },
      },
    },
    stepsContainer: {
      gap: 0,
      paddingTop: {base: 10, lg: 0},
      sx : {
        '& .toggle-card:first-child': {
          '& .chakra-heading': {
            color: 'greyscale.100',
          }
        },
      }
    },

    addressGrid: {
      columns: [1, 1, 2],
      spacing: 4,
      paddingTop: {base: '24px', lg: 0},
    },
    addressTile: {
      backgroundColor: 'white',
      border: '1px solid',
      borderColor: 'grayAlpha.10',
      borderRadius: 'base',
      cursor: 'pointer',
      padding: 4,
      position: 'relative',
      textAlign: 'left',
      transition: 'border-color 0.15s ease',
      width: '100%',
      minHeight: '158px',
      _hover: {
        borderColor: 'grayAlpha.10',
      },
    },
    addressTileSelected: {
      borderColor: 'grayAlpha.90',
      borderWidth: '2px',
      padding: 'calc(var(--chakra-space-4) - 1px)',
    },
    addressTileRadio: {
      alignItems: 'center',
      border: '1px solid',
      borderColor: 'grayAlpha.10',
      borderRadius: 'full',
      display: 'flex',
      flexShrink: 0,
      height: 8, // 32px
      justifyContent: 'center',
      transition: 'border-color 0.15s ease',
      width: 8,
    },
    addressTileRadioInner: {
      backgroundColor: 'brandColors.greyscale90',
      borderRadius: 'full',
      height: 5.5,
      width: 5.5,
    },
    addressTileBadge: {
      backgroundColor: 'brandColors.greyscale90',
      color: 'white',
      fontSize: {'base': '13px', 'lg': 'xs'},
      fontWeight: '600',
      lineHeight: '13px',
      paddingX: 2,
      paddingTop: 0.5,
      paddingBottom: 0.75,
      position: 'absolute',
      right: 4,
      borderRadius: 'base',
      textTransform: 'capitalize',
      top: 4,
    },
    addressTileName: {
      ...typography.textStyles.labelDefault,
      color: 'greyscale.100',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontVariantNumeric: 'lining-nums proportional-nums',
      marginBottom: 2,
    },
    addressTileAddress: {
      ...typography.textStyles.bodyDefault,
      color: 'brandColors.greyscale80',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontVariantNumeric: 'lining-nums proportional-nums',
      sx: {
        '& .chakra-text': {
          color: 'brandColors.greyscale80',
          fontFamily: 'body',
          fontFeatureSettings: "'lnum' 1, 'pnum' 1",
          fontSize: {base: '0.875rem', lg: '1rem'},
          fontStyle: 'normal',
          fontVariantNumeric: 'lining-nums proportional-nums',
          fontWeight: 400,
          lineHeight: 1.4,
        },
      },
    },
    addressTileActions: {
      display: 'flex',
      gap: 8,
      marginTop: 3,
    },
    addressTileActionLink: {
      color: 'brandColors.primaryDarkLinen',
      fontSize: {'base': '14px', 'lg': '16px'},
      fontWeight: {'base': '600', 'lg': '400'},
      height: 'auto',
      minWidth: 'auto',
      padding: {base: 0, lg: 0},
      textDecoration: 'underline',
      textUnderlineOffset: {'base': '3px', 'lg': '5.6px'},
      _hover: {
        textDecoration: 'none',
      },
    },
    addressTileAddNew: {
      bg: 'brandColors.primaryBG',
      border: '1px dashed',
      borderColor: 'brandColors.primaryDarkLinen',
      borderRadius: 'base',
      color: 'greyscale90Alpha.90',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      flex: '1 0 0',
      alignSelf: 'stretch',
      padding: {base: '22px 0', lg: '58px 0'}, 
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontWeight: 600,
      lineHeight: 'base',
      fontVariantNumeric: 'lining-nums proportional-nums',
      textAlign: 'center',
      width: '100%',
      minHeight: {base: '68px', lg: '158px'},
      display: 'flex',
      flexDirection: 'row',
      _hover: {
        backgroundColor: 'brandColors.secondaryBG',
        borderColor: 'brandColors.primaryDarkLinen',
      },
      sx: {
        '& .chakra-button__icon': {
          marginRight: 0,
        },
        '& svg': {
          color: 'brandColors.primaryDarkLinen',
        },
        '& span': {
          fontWeight: '600',
        },
      },
    },
    addressTileAddNewActive: {
      backgroundColor: 'brandColors.secondaryBG',
      borderColor: 'brandColors.primaryDarkLinen',
      borderStyle: 'dashed',
      borderWidth: '2px',
    },
    newAddressFormHeading: {
      ...typography.textStyles.labelL,
      color: 'grayAlpha.90',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      marginTop: 0,
      marginBottom: 6,
    },
    shippingWarningAlert: {
      marginTop: 2,
    },
    shippingMethodList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      width: '100%',
    },
    shippingMethodOption: {
      alignItems: 'flex-start',
      bg: 'white',
      border: '1.5px solid',
      borderColor: 'grayAlpha.10',
      borderRadius: 'base',
      cursor: 'pointer',
      display: 'flex',
      gap: 3,
      p: 4,
      textAlign: 'left',
      transition: 'border-color 0.15s ease',
      width: '100%',
      _focusVisible: {
        boxShadow: 'outline',
        outline: '2px solid',
        outlineColor: 'blue.500',
        outlineOffset: '2px',
      },
    },
    shippingMethodOptionSelected: {
      borderColor: 'grayAlpha.90',
    },
    shippingMethodRadio: {
      alignItems: 'center',
      border: '1.5px solid',
      borderColor: 'grayAlpha.10',
      borderRadius: 'full',
      display: 'flex',
      flexShrink: 0,
      height: 8,
      justifyContent: 'center',
      transition: 'border-color 0.15s ease',
      width: 8,
    },
    shippingMethodRadioSelected: {
      borderColor: 'grayAlpha.90',
    },
    shippingMethodRadioInner: {
      backgroundColor: 'grayAlpha.90',
      borderRadius: 'full',
      height: '22px',
      width: '22px',
    },
    shippingMethodContent: {
      display: 'flex',
      flex: '1 0 0',
      flexDirection: 'column',
      gap: 2,
      minW: 0,
      width: '100%',
    },
    shippingMethodHeaderRow: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      pb: 2,
      width: '100%',
    },
    shippingMethodTitle: {
      ...typography.textStyles.labelDefault,
      color: 'greyscale.100',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontVariantNumeric: 'lining-nums proportional-nums',
      wordBreak: 'break-word',
    },
    shippingMethodPrice: {
      ...typography.textStyles.labelDefault,
      color: 'greyscale.100',
      flexShrink: 0,
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontVariantNumeric: 'lining-nums proportional-nums',
      textAlign: 'right',
      whiteSpace: 'nowrap',
    },
    shippingMethodPriceColumn: {
      alignItems: 'flex-end',
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      gap: 0.5,
    },
    shippingMethodPriceOriginal: {
      ...typography.textStyles.bodyS,
      color: 'brandColors.greyscale70',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontVariantNumeric: 'lining-nums proportional-nums',
      textAlign: 'right',
      textDecoration: 'line-through',
      whiteSpace: 'nowrap',
    },
    shippingMethodDetailRow: {
      alignItems: {base: 'flex-start', lg: 'center'},
      display: 'flex',
      gap: 3,
      width: '100%',
    },
    shippingMethodDetailBullet: {
      backgroundColor: 'brandColors.greyscale80',
      borderRadius: 'full',
      flexShrink: 0,
      height: '4px',
      marginTop: {base: 2, lg: '0'},
      width: '4px',
    },
    shippingMethodDetailText: {
      ...typography.textStyles.bodyDefault,
      color: 'brandColors.greyscale80',
      flex: '1 0 0',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontVariantNumeric: 'lining-nums proportional-nums',
      minW: 0,
      wordBreak: 'break-word',
    },
    shippingMethodPromotion: {
      ...typography.textStyles.bodyS,
      color: 'success.standard',
      mt: 1,
    },
    shippingMethodSummary: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      width: '100%',
    },
    shippingMethodSummaryTitle: {
      ...typography.textStyles.bodyDefault,
      color: 'greyscale.100',
      fontWeight: 400,
      width: '100%',
    },
    shippingMethodSummaryLeadTime: {
      ...typography.textStyles.bodyDefault,
      color: 'greyscale.100',
      fontWeight: 400,
      width: '100%',
      sx: {
        '& .chakra-text': {
          ...typography.textStyles.bodyDefault,
          color: 'greyscale.100',
          fontWeight: 400,
        },
      },
    },
    shippingMethodSummaryDescription: {
      ...typography.textStyles.bodyDefault,
      color: 'greyscale.100',
    },
    shippingMethodSummaryPrice: {
      alignItems: 'flex-end',
      display: 'none',
      flexDirection: 'column',
      gap: 0.5,
    },
    shippingMethodSummaryAdjustment: {
      ...typography.textStyles.bodyS,
      color: 'success.standard',
      display: 'none',
    },
    paymentSectionHeading: {
      ...typography.textStyles.labelL,
      color: 'grayAlpha.90',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      lineHeight: {base: 1.4, lg: 1.2},
      width: '100%',
    },
    paymentMethodList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      width: '100%',
    },
    paymentMethodOption: {
      bg: 'white',
      border: '1px solid',
      borderColor: 'grayAlpha.10',
      borderRadius: {base: '6px', lg: 'base'},
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      pb: '24px',
      pt: '16px',
      px: '16px',
      width: '100%',
    },
    paymentMethodOptionSelected: {
      bg: 'white',
      border: '2px solid',
      borderColor: 'brandColors.greyscale90',
      borderRadius: 'base',
    },
    paymentMethodOptionCompact: {
      alignItems: 'center',
      bg: 'white',
      border: '1px solid',
      borderColor: 'brandColors.greyscale10',
      borderRadius: 'base',
      cursor: 'pointer',
      display: 'flex',
      gap: '12px',
      minH: '64px',
      p: '16px',
      textAlign: 'left',
      width: '100%',
    },
    paymentMethodHeaderRow: {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      gap: '12px',
      width: '100%',
    },
    paymentMethodTitle: {
      ...typography.textStyles.labelDefault,
      color: 'greyscale.100',
      flex: '1 0 0',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      minW: 0,
    },
    /** Figma PM logo badge — PayPal / BNPL: 51×32, keyline, 10px inset. */
    paymentMethodLogoBadge: {
      alignItems:     'center',
      aspectRatio:    '51 / 32',
      bg:             'white',
      border:         '1px solid',
      borderColor:    'grayAlpha.10',
      borderRadius:   '4px',
      boxSizing:      'border-box',
      display:        'flex',
      flexShrink:     0,
      height:         '32px',
      justifyContent: 'center',
      overflow:       'hidden',
      p:              '10px',
      width:          '51px',
      sx: {
        '& img, & svg': {
          height:     '100%',
          maxHeight:  '100%',
          maxWidth:   '100%',
          objectFit:  'contain',
          width:      '100%',
        },
      },
    },
    // Figma 3193:3322 — 34px ring #D6D2C5; inner dot #1B1A18 when selected.
    paymentMethodRadio: {
      alignItems:     'center',
      border:         '1.5px solid',
      borderColor:    'brandColors.linen03',
      borderRadius:   'full',
      display:        'flex',
      flexShrink:     0,
      height:         '34px',
      justifyContent: 'center',
      transition:     'border-color 0.15s ease',
      width:          '34px',
    },
    paymentMethodRadioSelected: {
      borderColor: 'brandColors.linen03',
    },
    paymentMethodRadioInner: {
      backgroundColor: 'grayAlpha.90',
      borderRadius:    'full',
      height:          '24px',
      width:           '24px',
    },
    paymentMethodCardForm: {
      width: '100%',
    },
    stripePaymentElementContainer: {
      width: '100%',
    },
    paymentAmountList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      width: '100%',
    },
    paymentAmountOption: {
      alignItems: 'center',
      bg: 'white',
      border: '1px solid',
      borderColor: 'grayAlpha.10',
      borderRadius: 'base',
      cursor: 'pointer',
      display: 'flex',
      gap: '12px',
      p: '16px',
      textAlign: 'left',
      width: '100%',
    },
    paymentAmountOptionSelected: {
      border: '2px solid',
      borderColor: 'grayAlpha.90',
      borderRadius: 'base',
    },
    paymentAmountContent: {
      display: 'flex',
      flex: '1 0 0',
      flexDirection: 'column',
      gap: '8px',
      minW: 0,
    },
    paymentAmountTitle: {
      ...typography.textStyles.labelDefault,
      color: 'greyscale.100',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      width: '100%',
    },
    paymentAmountSubtitle: {
      ...typography.textStyles.bodyDefault,
      color: 'brandColors.greyscale80',
      width: '100%',
    },
    paymentAmountPrice: {
      ...typography.textStyles.labelDefault,
      color: '#000',
      flexShrink: 0,
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      textAlign: 'right',
      whiteSpace: 'nowrap',
    },
    addressFormActions: {
      alignItems: 'stretch',
      flexDirection: {base: 'column', lg: 'row'},
      gap: 4,
      width: '100%',
    },
    addressFormSaveButton: {
      height: '54px',
      minH: '54px',
      borderRadius: 'base',
      fontFamily: 'body',
      fontSize: 'md',
      fontStyle: 'normal',
      fontVariantNumeric: 'lining-nums proportional-nums',
      fontWeight: '600',
      lineHeight: 1.4,
      flex: {base: 'unset', lg: '1 0 0'},
      px: 12,
      py: 4,
      width: '100%',
      transition: 'all 0.2s ease',
      bg: 'brandColors.greyscale',
      border: '1px solid',
      borderColor: 'brandColors.greyscale',
      color: 'white',
      _hover: CHECKOUT_FILLED_BUTTON_HOVER,
      _active: CHECKOUT_FILLED_BUTTON_HOVER,
      _disabled: {
        bg: 'brandColors.greyscale10',
        border: 'none',
        color: 'greyscale.50',
        cursor: 'not-allowed',
        opacity: 1,
        fontWeight: '600',
        _hover: {
          bg: 'brandColors.greyscale10',
          border: 'none',
          color: 'greyscale.50',
        },
      },
    },
    addressFormCancelButton: {
      height: '54px',
      minH: '54px',
      borderRadius: 'base',
      fontFamily: 'body',
      fontSize: 'md',
      fontStyle: 'normal',
      fontVariantNumeric: 'lining-nums proportional-nums',
      fontWeight: '600',
      lineHeight: 1.4,
      flex: {base: 'unset', lg: '1 0 0'},
      px: 12,
      py: 4,
      width: '100%',
      transition: 'all 0.2s ease',
      bg: 'white',
      border: '1px solid',
      borderColor: 'brandColors.greyscale',
      color: 'brandColors.greyscale',
      _hover: CHECKOUT_OUTLINED_BUTTON_HOVER,
      _active: CHECKOUT_OUTLINED_BUTTON_HOVER,
      _disabled: {
        opacity: 0.5,
        cursor: 'not-allowed',
      },
    },
    submitButton: {
      height: '54px',
      minH: '54px',
      borderRadius: 'base',
      fontFamily: 'body',
      fontSize: {base: 'sm', lg: 'md'},
      fontStyle: 'normal',
      fontVariantNumeric: 'lining-nums proportional-nums',
      fontWeight: '600',
      lineHeight: {base: 1.2, lg: 1.4},
      px: 12,
      py: 4,
      width: '100%',
      transition: 'all 0.2s ease',
      bg: 'brandColors.greyscale',
      border: '1px solid',
      borderColor: 'brandColors.greyscale',
      color: 'white',
      _hover: CHECKOUT_FILLED_BUTTON_HOVER,
      _active: CHECKOUT_FILLED_BUTTON_HOVER,
      _disabled: {
        bg: 'brandColors.greyscale10',
        border: 'none',
        color: 'greyscale.50',
        cursor: 'not-allowed',
        opacity: 1,
        fontWeight: '600',
        _hover: {
          bg: 'brandColors.greyscale10',
          border: 'none',
          color: 'greyscale.50',
        },
      },
    },
  },
};

export default CheckoutPage;
